import React from 'react';
import {RadiusView} from 'src/res/Radius';
import {FontWeightMedium} from 'src/res/FontWeight';
import {logDebug} from "../../utils/AppLog";
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import ImageBackground from "../commons/ImageBackground";
import AppImage from "../commons/AppImage";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppUtils from "../../utils/AppUtils";
import {
  GAME_BOMB_AUDIO,
  GAME_CRUSH_AUDIO,
  GAME_NEUTRAL_AUDIO,
  GAME_TIMER_AUDIO,
  GAME_WIN_AUDIO
} from "../../utils/GameAudioPlayer";
import AppText from "../commons/AppText";
import FocusHelperView from "../commons/FocusHelperView";
import GameAudio from "../commons/GameAudio";
import {animated, SpringValue} from '@react-spring/web';
import ActivityHelper from "../../utils/ActivityHelper";
import {useSwipeable} from "react-swipeable";

// import GestureRecognizer from 'react-native-swipe-gestures';

export default class GameMatchThreeView extends React.PureComponent {

  constructor(props) {
    super(props);
    this.gameLastTime = 0;
    this.endGameProcessStartTime = 0;

    this.state = this.getDefaultState();
  }

  componentWillUnmount() {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
      this.timeoutRef = null;
    }
    this.stopGameTimer();
    this.refGrid = null;
  }

  onDidFocus = () => {
    if (this.wasTimerRunning) {
      this.startGameTimer();
    }
  }

  onDidBlur = () => {
    if (this.intervalHandler) {
      this.wasTimerRunning = true;
      this.stopGameTimer();
    }
  }

  simulatePlay = () => {
    if (!this.state.isGameOver) {
      const delay = 500 + Math.floor(Math.random() * 1000);
      this.timeoutRef = setTimeout(() => {
        if (!this.state.isGameOver) {
          this.swipeRandom();
          this.simulatePlay();
        }
      }, delay);
    }
  }

  swipeRandom = () => {
    if (this.refGrid) {
      let swipe = null;
      if (Math.random() > 0.5) {
        swipe = this.findCombo();
      }
      if (!swipe) {
        const index = Math.floor(Math.random() * 100) % (this.props.rows * this.props.columns);
        const i = index % this.props.rows;
        const j = Math.floor(index / this.props.columns);
        const gestures = ['SWIPE_UP', 'SWIPE_DOWN', 'SWIPE_LEFT', 'SWIPE_RIGHT'];
        const gestureIndex = Math.floor(Math.random() * 100) % gestures.length;
        swipe = {i, j, move: gestures[gestureIndex]}
      }

      this.refGrid.swapIJGesture(swipe.j, swipe.i, swipe.move);
    }
  }

  findCombo() {
    let gridDS = this.refGrid.getGridData();
    let grid = [];
    gridDS.forEach((items) => {
      const itemsN = [];
      items.forEach((item) => {
        itemsN.push(item.data.id);
      });
      grid.push(itemsN);
    });
    const rows = grid.length;
    const cols = grid[0].length;

    // Helper function to check combos in the grid
    const hasCombo = () => {
      // Check horizontal combos
      for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols - 2; j++) {
          if (
            grid[i][j] === grid[i][j + 1] &&
            grid[i][j] === grid[i][j + 2] &&
            grid[i][j] !== 0
          ) {
            return true;
          }
        }
      }

      // Check vertical combos
      for (let i = 0; i < rows - 2; i++) {
        for (let j = 0; j < cols; j++) {
          if (
            grid[i][j] === grid[i + 1][j] &&
            grid[i][j] === grid[i + 2][j] &&
            grid[i][j] !== 0
          ) {
            return true;
          }
        }
      }

      return false;
    };

    // Try all moves
    for (let i = 0; i < rows; i++) {
      for (let j = 0; j < cols; j++) {
        // Top
        if (i > 0) {
          [grid[i][j], grid[i - 1][j]] = [grid[i - 1][j], grid[i][j]];
          if (hasCombo()) return { i, j, move: "SWIPE_UP" };
          [grid[i][j], grid[i - 1][j]] = [grid[i - 1][j], grid[i][j]]; // Revert
        }

        // Bottom
        if (i < rows - 1) {
          [grid[i][j], grid[i + 1][j]] = [grid[i + 1][j], grid[i][j]];
          if (hasCombo()) return { i, j, move: "SWIPE_DOWN" };
          [grid[i][j], grid[i + 1][j]] = [grid[i + 1][j], grid[i][j]]; // Revert
        }

        // Left
        if (j > 0) {
          [grid[i][j], grid[i][j - 1]] = [grid[i][j - 1], grid[i][j]];
          if (hasCombo()) return { i, j, move: "SWIPE_LEFT" };
          [grid[i][j], grid[i][j - 1]] = [grid[i][j - 1], grid[i][j]]; // Revert
        }

        // Right
        if (j < cols - 1) {
          [grid[i][j], grid[i][j + 1]] = [grid[i][j + 1], grid[i][j]];
          if (hasCombo()) return { i, j, move: "SWIPE_RIGHT" };
          [grid[i][j], grid[i][j + 1]] = [grid[i][j + 1], grid[i][j]]; // Revert
        }
      }
    }

    return null; // No move found
  }

  resetForPreview(items) {
    this.reset(items);
  }

  reset(items) {
    this.stopGameTimer(false);
    setTimeout(() => {
      this.items = items;
      const currentTime = new Date().getTime();
      const idleTime = 2 * 1000;
      const resetAfter = Math.max(0, idleTime - (currentTime - this.endGameProcessStartTime));

      setTimeout(() => {
        this.endGameProcessStartTime = 0;
        this.setState(this.getDefaultState());
        if (this.refGrid) {
          this.refGrid.reset(this.items);
        }
      }, resetAfter);
    }, 100);
  }

  getDefaultState() {
    return {
      isGameOver: false,
      isWin: false,
      isLose: false,
      gameTimer: 0,
      movesCount: 0,
      points: this.props.value,
    };
  }

  playGamePlayAudio() {
    if (this.gamePlayAudioId) {
      this.gamePlayAudioId.play();
    }
  }

  playGameTimerAudio() {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.play();
    }
  }

  stopGameTimerAudio() {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.pause();
    }
  }

  render() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const isDisabled = this.props.disabled;
    const rows = this.props.rows;
    const columns = this.props.columns;
    const isRTL = !this.props.isLTR;

    const cardSize = this.getCardSize();
    const cardSpacing = this.getCardSpacing();
    const gameViewWidth = Math.ceil((cardSize + cardSpacing) * columns + 1);
    const gameViewHeight = Math.ceil((cardSize + cardSpacing) * rows + 1);
    const gameBgMargin = uiConfigs.gameBgMarginStartEnd * sizeFactor;
    const gameBgMarginTop = uiConfigs.gameBgMarginTop * sizeFactor;
    const gameBgMarginBottom = uiConfigs.gameBgMarginBottom * sizeFactor;

    const gameTimeLeft = ActivityHelper.getGameTimeText(this.props.gameTime - this.state.gameTimer);
    const showMovesCount = this.props.flipsNeeded && (this.props.flipsNeeded < 10000 || this.props.flipsNeeded - this.state.movesCount < 10000);
    let flipsCountText = null;
    if (showMovesCount) {
      flipsCountText = Math.max(0, this.props.flipsNeeded - this.state.movesCount);
    }

    const score = this.state.points || 0;
    const winValue = this.props.winValue;
    const progressViewWidth = cardSize * 3;
    const progressSpace = 4;
    let progressWidth = winValue > 0 ? progressViewWidth * Math.min(score/winValue, 1) - progressSpace : 0;
    if (progressWidth === -progressSpace) {
      progressWidth = 0;
    } else if (progressWidth < 1) {
      progressWidth = 1;
    } else if (progressWidth > progressViewWidth - 2 * progressSpace) {
      progressWidth = progressViewWidth - 2 * progressSpace;
    }

    let contentY = this.props.contentY + 36 * sizeFactor + gameBgMarginTop;
    if (flipsCountText || this.props.gameTime) {
      contentY+= 48 * sizeFactor
    }
    return (
      <View style={{alignItems: 'center'}}>
        <FocusHelperView
          onNavigationDidFocus={this.onDidFocus}
          onNavigationDidBlur={this.onDidBlur}
          onAppDidFocus={this.onDidFocus}
          onAppDidBlur={this.onDidBlur}
        />
        {!this.props.disableAudio ?
          <div>
            <GameAudio ref={(ref) => this.gamePlayAudioId = ref} source={this.props.gamePlayAudioUrl || GAME_CRUSH_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gameTimerAudioId = ref} source={GAME_TIMER_AUDIO} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gameBomAudioId = ref} source={GAME_BOMB_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdNeutral = ref} source={GAME_NEUTRAL_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
          </div>
          : null
        }
        {showMovesCount || this.props.gameTime ?
          <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: 8, paddingTop: 0, marginBottom: 2 * sizeFactor, marginTop: -8 * sizeFactor}}>
            {showMovesCount ?
              <ImageBackground source={uiConfigs.tryCounterImage} resizeMode="fill" style={{height: 44 * sizeFactor, width: 130 * sizeFactor, flexDirection: 'row', alignItems: 'center', paddingTop: 4, marginLeft: 30, marginRight: 30}} >
                <AppText fontSizeN={uiConfigs.fontSize} style={{flex: 1, marginLeft: isRTL ? 4 : 46, marginRight: isRTL ? 46 : 4, justifyContent: 'center', fontSize: 18, fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor}}>
                  {flipsCountText}
                </AppText>
              </ImageBackground>
              : null
            }
            {this.props.gameTime ?
              <ImageBackground source={uiConfigs.timerImage} resizeMode="fill" style={{height: 44 * sizeFactor, width: 130 * sizeFactor, display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: 4 * sizeFactor, marginLeft: 30, marginRight: 30}} >
                <AppText fontSizeN={uiConfigs.fontSize} style={{position: 'relative', flex: 1, marginLeft: 44, marginRight: 4, align: 'center', fontSize: 18, fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor}}>
                  {gameTimeLeft}
                </AppText>
              </ImageBackground>
              : null
            }
          </View>
          : null
        }
        {/*<ImageBackground source={uiConfigs.gameTopImage} resizeMode="fill" style={{height: 36 * sizeFactor, width: 180 * sizeFactor, alignItems: 'center', justifyContent: 'center', marginBottom: -2 * sizeFactor}}>*/}
        {/*  <AppText fontSizeN={uiConfigs.fontSize} style={{flex: 1, justifyContent: 'center', alignItems: 'center', fontSize: 20, fontWeight: FontWeightMedium, color: uiConfigs.gameValue1TextColor, textAlign: 'center'}}>*/}
        {/*    {this.state.points}*/}
        {/*  </AppText>*/}
        {/*</ImageBackground>*/}

        <View style={{position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: 4}} >
          <View style={{width: progressViewWidth, height: 32 * sizeFactor, borderRadius: 16 * sizeFactor, borderWidth: 4 * sizeFactor, borderColor: 'rgb(177,90,35)', borderStyle: 'ridge', backgroundColor: 'rgb(231,139,76)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden'}}>
            <View style={{position: 'absolute', top: progressSpace, bottom: progressSpace, left: progressSpace, width: progressWidth, borderRadius: 28, backgroundImage: 'linear-gradient(rgb(249,223,228), rgb(253,247,250))'}} />
            <AppText fontSizeN={uiConfigs.fontSize} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValue1TextColor, textAlign: 'center'}}>
              {score || '0'}
            </AppText>
          </View>
        </View>

        <ImageBackground source={uiConfigs.gameBgImage} resizeMode="fill" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', height: gameViewHeight + gameBgMarginTop + gameBgMarginBottom, width: gameViewWidth + 2 * gameBgMargin, overflow: 'hidden', opacity: isDisabled ? 0.8 : 1}}>
          <SwappableGrid
            ref={(ref) => this.refGrid = ref}
            isLTR={this.props.isLTR}
            items={this.props.items}
            rows={this.props.rows}
            columns={this.props.columns}
            size={cardSize}
            onSwapEnd={this.onChange}
            contentY={contentY}
            contentX={(this.props.contentWidth - gameViewWidth) / 2}
          />
          {this.state.isGameOver || isDisabled
            ? <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, zIndex: 1}} />
            : null
          }
          {!this.props.simulation && (this.state.isWin || this.state.isLose) ?
            <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, alignItems: 'center', justifyContent: 'center'}}>
              {/*<View>*/}
              {/*  <View style={{padding: 8, paddingLeft: 16, paddingRight: 16, marginBottom: 4, backgroundColor: AppUtils.colorWithAlpha(uiConfigs.messageBgColor, 0.9), borderRadius: 20}}>*/}
              {/*    <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{color: uiConfigs.titleColor, fontWeight: FontWeightMedium, textAlign: 'center'}}>*/}
              {/*      {this.state.isWin ? locString('youWon') : locString('gameEndedNScore', {value: this.state.points})}*/}
              {/*    </AppText>*/}
              {/*  </View>*/}
                <CircularProgress size={32 * sizeFactor} style={{color: uiConfigs.messageBgColor}}/>
              {/*</View>*/}
            </View>
            : null
          }
        </ImageBackground>
      </View>
    );
  }

  onChange = (isCounterUpdated, points) => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }
    if (this.state.movesCount === 0) {
      if (this.props.onStart) {
        this.props.onStart();
      }
    }

    logDebug('onSwapChange', {isCounterUpdated, points});
    this.startGameTimer();
    const movesCount = isCounterUpdated ? this.state.movesCount + 1 : this.state.movesCount;
    const pointsEarned = this.state.points + points;
    const isGameOver = this.processGameResult(pointsEarned, movesCount, this.state.gameTimer);
    if (isGameOver) {
      this.stopGameTimer();
    }
    this.setState({
      movesCount: movesCount,
      points: pointsEarned,
      isGameOver: isGameOver
    });
    if (points > 0) {
      this.playGamePlayAudio();
    }
  };

  startGameTimer() {
    if (this.props.gameTime && !this.intervalHandler) {
      this.gameLastTime = new Date().getTime();
      this.intervalHandler = setInterval(() => {
        this.updateTimeElapsed();
      }, 500);
      this.playGameTimerAudio();
    }
  }

  stopGameTimer(updateElapsed = true) {
    if (this.intervalHandler) {
      this.stopGameTimerAudio();
      clearInterval(this.intervalHandler);
      this.intervalHandler = null;
      if (updateElapsed) {
        this.updateTimeElapsed();
      }
    }
  }

  updateTimeElapsed() {
    let isGameOver = false;

    const currentTime = new Date().getTime();
    const timeDiff = currentTime - this.gameLastTime;
    this.gameLastTime = currentTime;
    const timeElapsed = Math.min(this.state.gameTimer + timeDiff, this.props.gameTime);
    const timeOver = timeElapsed >= this.props.gameTime;
    if (timeOver) {
      this.stopGameTimer();
      isGameOver = this.processGameResult(this.state.points, this.state.movesCount, timeElapsed);
    }
    this.setState({
      gameTimer: timeElapsed,
      isGameOver: isGameOver
    });
  }

  isGameWin(pointsEarned) {
    return false;
  }

  isPlayEnded(movesCount, gameTimer) {
    if (this.props.flipsNeeded && this.props.flipsNeeded <= movesCount) {
      return true;
    }
    return this.props.gameTime && this.props.gameTime <= gameTimer;
  }

  processGameResult(pointsEarned, movesCount, gameTimer) {
    if (this.isGameWin(pointsEarned)) {
      setTimeout(() => {
        this.processGameEnd(true);
        this.setState({isWin: true, isLose: false});
      }, 400);
      return true;
    } else if (this.isPlayEnded(movesCount, gameTimer)) {
      setTimeout(() => {
        this.processGameEnd(false);
        this.setState({isWin: false, isLose: true});
      }, 200);
      return true;
    }
    return false;
  }

  processGameEnd(isWin) {
    if (!this.endGameProcessStartTime) {
      this.endGameProcessStartTime = new Date().getTime();

      // Vibration.vibrate(200);
      if (isWin) {
        if (this.gamePlayAudioIdWin) {
          this.gamePlayAudioIdWin.play();
        }
      } else {
        if (this.gamePlayAudioIdNeutral) {
          this.gamePlayAudioIdNeutral.play();
        }
      }

      if (this.props.onEnd) {
        this.props.onEnd({isWin: isWin, value: this.state.points, timer: this.state.gameTimer});
      }
    }
  }

  getCardSize() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const rows = this.props.rows;
    const columns = this.props.columns;

    const cardSpacing = this.getCardSpacing();
    const otherUiHeight = 130 * sizeFactor;
    const borderWidth = 2 * uiConfigs.gameBgMarginStartEnd * sizeFactor;
    const borderHeight = (uiConfigs.gameBgMarginTop + uiConfigs.gameBgMarginBottom) * sizeFactor;
    const possibleWidth = (this.props.contentWidth - borderWidth - (columns + 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
    const possibleHeight = (this.props.contentHeight - otherUiHeight - borderHeight - (rows + 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card
    const possibleSize = Math.min(possibleWidth, possibleHeight);
    const cardSize = Math.floor(Math.min(200, possibleSize));
    return cardSize;
  }

  getCardSpacing() {
    return 0;
  }
}

class SwappableGrid extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      tileDataSource: this.initializeDataSource(this.props.items),
    };
    this.gridOrigin = [this.props.contentX, this.props.contentY];
  }

  componentWillUnmount() {
    this.refSwipeView = null;
  }

  reset(items) {
    this.setState({tileDataSource: this.initializeDataSource(items), play: false}, () => {
      this.animateValuesToLocations();
    });
  }

  getGridData() {
    return this.state.tileDataSource;
  }

  swap(x, y, dx, dy) {
    const xC = x + dx;
    const yC = y + dy;
    if (x < 0 || x >= this.props.columns || y < 0 || y >= this.props.rows
      || xC < 0 || xC >= this.props.columns || yC < 0 || yC >= this.props.rows) {
      return;
    }

    const swapStarter = this.state.tileDataSource[y][x];
    const swapEnder = this.state.tileDataSource[yC][xC];

    this.state.tileDataSource[y][x] = swapEnder;
    this.state.tileDataSource[yC][xC] = swapStarter;

    swapStarter.locationX.update({
      config: {
        duration: 120,
      },
      to: this.props.size * (xC),
    }).start();
    swapStarter.locationY.update({
      config: {
        duration: 120,
      },
      to: this.props.size * (yC),
    }).start();

    const onAnimationEnd = () => {
      let allMatches = this.getAllMatches(this.state.tileDataSource);
      if (allMatches.length === 0) {
        if (this.props.onSwapEnd) {
          this.props.onSwapEnd(true, 0);
        }
      } else {
        this.processMatches(allMatches, 0);
      }
    };
    const newX = this.props.size * x;
    const newY = this.props.size * y;
    swapEnder.locationX.update({
      config: {
        duration: 120,
      },
      to: newX,
    }).start().then(() => {
      // if (swapEnder.locationX.get() !== newX) {
      //   onAnimationEnd();
      // }
    });
    swapEnder.locationY.update({
      config: {
        duration: 120,
      },
      to: newY,
    }).start().then(() => {
      // if (swapEnder.locationY.get() !== newY) {
        onAnimationEnd();
      // }
    });

    // const animateSwap = Animated.parallel([
    //   Animated.timing(swapStarter.location, {
    //     toValue: {x: this.props.size * (xC), y: this.props.size * (yC)},
    //     duration: 120,
    //     useNativeDriver: true,
    //   }),
    //   Animated.timing(swapEnder.location, {
    //     toValue: {x: this.props.size * x, y: this.props.size * y},
    //     duration: 120,
    //     useNativeDriver: true,
    //   }),
    // ]);
    // animateSwap.start(() => {
    //   let allMatches = this.getAllMatches(this.state.tileDataSource);
    //   if (allMatches.length == 0) {
    //     if (this.props.onSwapEnd) {
    //       this.props.onSwapEnd(true, 0);
    //     }
    //   } else {
    //     this.processMatches(allMatches, 0);
    //   }
    // });
  }

  processMatches(matches, counter) {
    counter++;
    let value = 0;
    let nextMatches = [];

    this.setState((state => {
      // Create a copy to our existing tileDataSource
      let newTileDataSource = state.tileDataSource.slice();
      // Mark matches for update.
      value = this.markAsMatch(matches, newTileDataSource, counter);
      // Repositioning tiles marked for update.
      this.condenseColumns(newTileDataSource);
      // Recoloring those tiles & reseting update status.
      this.recolorMatches(newTileDataSource);
      // Get the matches from our new state.
      nextMatches = this.getAllMatches(newTileDataSource);
      //
      return {tileDataSource: newTileDataSource};
    }), () => {
      if (this.props.onSwapEnd) {
        this.props.onSwapEnd(counter === 1, value);
      }
      this.animateValuesToLocations();
    });

    // If the matches
    if (nextMatches.length != 0) {
      setTimeout(() => {
        this.processMatches(nextMatches, counter);
      }, 250);
    }
  }

  recolorMatches(tileData) {
    tileData.forEach(row => {
      row.forEach(e => {
        if (e.markedAsMatch == true) {
          let randIndex = AppUtils.getRandomInt(this.props.items.length);
          let randomBeanObj = this.props.items[randIndex];
          e.markedAsMatch = false;
          e.data = randomBeanObj;
        }
      });
    });
  }

  onSwipe(gestureName, gestureState) {
    let initialGestureX = gestureState.x0;
    let initialGestureY = gestureState.y0;

    let gridOrigin = null;
    if (this.refSwipeView) {
      const rect = this.refSwipeView.getBoundingClientRect();
      if (rect) {
        gridOrigin = [rect.x, rect.y];
      }
      logDebug('positionHere', gridOrigin);
    }
    if (!gridOrigin) {
      gridOrigin = this.gridOrigin;
    }

    const i = Math.min(this.props.columns - 1, Math.max(0, Math.round((initialGestureX - gridOrigin[0] - 0.5 * this.props.size) / this.props.size)));
    const j = Math.min(this.props.rows - 1, Math.max(0, Math.round((initialGestureY - gridOrigin[1] - 0.5 * this.props.size) / this.props.size)));
    logDebug('SWAP_IJ', {i: i, j: j, size: this.props.size, gridOrigin: gridOrigin, initialGestureX, initialGestureY});

    this.swapIJGesture(i, j, gestureName);
  }

  swapIJGesture(i, j, gestureName) {
    switch (gestureName) {
      case 'SWIPE_UP':
        this.swap(i, j, 0, -1);
        break;
      case 'SWIPE_DOWN':
        this.swap(i, j, 0, 1);
        break;
      case 'SWIPE_LEFT':
        this.swap(i, j, -1, 0);
        break;
      case 'SWIPE_RIGHT':
        this.swap(i, j, 1, 0);
        break;
    }
  }

  renderTiles(tileData) {
    let tiles = [];
    tileData.forEach((row, i) => {
      row.forEach((column, j) => {
        // e is a singular TileData class.
        tiles.push(
          <Tile
            size={this.props.size}
            location={column.location}
            locationX={column.locationX}
            locationY={column.locationY}
            scale={column.scale}
            key={column.key}
            img={column.data.imageUrl}
          />
        );
      });
    });
    return tiles;
  }

  initializeDataSource(items) {
    // Grid that contains the keys that will be assigned to each tile via map
    let keys = [];
    for (let y = 0; y < this.props.rows; y++) {
      let rows = [];
      for (let x = 0; x < this.props.columns; x++) {
        rows.push(y * this.props.columns + x);
      }
      keys.push(rows);
    }
    // let keys = [
    //     [0, 1, 2, 3, 4],
    //     [5, 6, 7, 8, 9],
    //     [10, 11, 12, 13, 14],
    //     [15, 16, 17, 18, 19],
    //     [20, 21, 22, 23, 24],
    // ];

    return keys.map((row, y) => {
      return row.map((key, x) => {
        let int = AppUtils.getRandomInt(items.length);
        let randomBeanObj = items[int];
        return new TileData(randomBeanObj, key, y);
      });
    });
  }

  componentDidMount() {
    this.animateValuesToLocations();
  }

  onLayout(event) {
    logDebug('onLayout', event);
    this.gridOrigin = [this.props.contentX, event.nativeEvent.layout.y + this.props.contentY];
  }

  // Animates the values in the tile data source based on their index in the array.
  animateValuesToLocations() {
    this.state.tileDataSource.forEach((row, y) => {
      row.forEach((elem, x) => {
        const toLocation = {x: this.props.size * x, y: this.props.size * y};
        // const fromLocation = elem.location;
        // Animated.timing(fromLocation, {
        //   toValue: toLocation,
        //   duration: 250,
        // }).start();

        elem.locationX.set(toLocation.x);
        if (elem.locationY.get() === toLocation.y) {
          elem.locationY.set(toLocation.y);
        } else {
          elem.locationY.update({
            config: {
              duration: 200,
            },
            from: 0,
            to: toLocation.y,
          }).start();
        }
      });
    });
  }

  render() {
    const isRTL = !this.props.isLTR;
    const config = {
      velocityThreshold: 0.11,
      directionalOffsetThreshold: 50,
    };

    return (
      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 4,
          touchAction: 'none'
        }}
        ref={(ref) => {
          if (ref) {
            this.refSwipeView = ref;
            const rect = ref.getBoundingClientRect();
            if (rect) {
              this.gridOrigin = [rect.x, rect.y];
              logDebug('positionHere1', this.gridOrigin);
            }
          }
        }}
      >
        <SwipeWrapperView
          size={this.props.size}
          onSwipeLeft={(eventData) => {
            const {initial} = eventData;
            logDebug('onSwipeLeft', eventData);
            this.onSwipe('SWIPE_LEFT', {x0: initial[0], y0: initial[1]})
          }}
          onSwipeRight={(eventData) => {
            const {initial} = eventData;
            logDebug('onSwipeRight', eventData);
            this.onSwipe('SWIPE_RIGHT', {x0: initial[0], y0: initial[1]})
          }}
          onSwipeUp={(eventData) => {
            const {initial} = eventData;
            logDebug('onSwipeUp', eventData);
            this.onSwipe('SWIPE_UP', {x0: initial[0], y0: initial[1]})
          }}
          onSwipeDown={(eventData) => {
            const {initial} = eventData;
            logDebug('onSwipeDown', eventData);
            this.onSwipe('SWIPE_DOWN', {x0: initial[0], y0: initial[1]})
          }}
          // onSwipe={(direction, state) => this.onSwipe(direction, state)}
          >
          <div
            style={{
              position: 'relative',
              display: 'flex',
              width: this.props.size * this.props.columns,
              height: this.props.size * this.props.rows,
              flexDirection: isRTL ? 'row-reverse' : 'row',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {this.renderTiles(this.state.tileDataSource)}
          </div>
        </SwipeWrapperView>
      </div>
    );
  }

  flattenArrayToPairs(arr) {
    let flatterArray = [];

    arr.map((row, i) => {
      row.map((e, j) => {
        flatterArray.push(e);
      });
    });

    if (Array.isArray(flatterArray[0]) == false) {
      return arr;
    }

    return this.flattenArrayToPairs(flatterArray);
  };

  isMatch(objOne, objTwo) {
    if (objOne != null && objTwo != null) {
      if (objOne.id === objTwo.id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  // Iterates through each row to look for a match.
  checkRowsForMatch(tileData) {
    // Store the array of matches
    let matches = []
// Iterate through the rows from top to bottom.
    for (let y = 0; y < this.props.rows; y++) {
      // Record the first index in the row.
      let firstIndex = [y,0]
      // Add the index to our potentialMatch
      let potentialMatch = [firstIndex]
      // Record the imgage object corresponding to the first element in our potentialMatch
      let currentImageObj = tileData[y][0].data
// Traverse the elements of the row.
      for (let x = 0; x < this.props.columns; x++) {
// Get the object stored in the next tile. Set to null if the next index is out of range.
        let nextTileObj = (x+1) < this.props.columns ? tileData[y][x+1].data: null
        if (nextTileObj) {
          logDebug('isRowsMatch', [y, x + 1]);
        }
        if (this.isMatch(currentImageObj, nextTileObj)) {
          // Add the next index to our potential Match.
          potentialMatch.push([y,x+1])
          logDebug('MatchFoundRow', [y,x+1]);
        } else {
          // Check to see if the potentialMatch is greater than 3.
          if (potentialMatch.length >= 3) {
            matches.push(potentialMatch)
          }
          // Reset the first index.
          firstIndex = [y,x+1]
          // Add it to the potentialMatch
          potentialMatch = [firstIndex]
          // Reset the current imageObj to that of the next image.
          currentImageObj = (x+1) < this.props.columns ? tileData[y][x+1].data: null
        }
      }
    }
    return matches
  }

  checkColsForMatch(tileData) {
    // Store the array of matches
    let matches = []
// Iterate through the rows from top to bottom.
    for (let x = 0; x < this.props.columns; x++) {
      // Record the first index in the row.
      let firstIndex = [0,x]
      // Add the index to our potentialMatch
      let potentialMatch = [firstIndex]
      // Record the imgage object corresponding to the first element in our potentialMatch
      let currentImageObj = tileData[0][x].data
// Traverse the elements of the row.
      for (let y = 0; y < this.props.rows; y++) {
// Get the object stored in the next tile. Set to null if the next index is out of range.
        let nextTileObj = (y+1) < this.props.rows ? tileData[y+1][x].data: null
        if (nextTileObj) {
          logDebug('isColsMatch', [y + 1, x]);
        }
        if (this.isMatch(currentImageObj, nextTileObj)) {
          // Add the next index to our potential Match.
          potentialMatch.push([y+1,x])
          logDebug('MatchFoundColumn', [y+1,x]);
        } else {
          // Check to see if the potentialMatch is greater than 3.
          if (potentialMatch.length >= 3) {
            matches.push(potentialMatch)
          }
          // Reset the first index.
          firstIndex = [y+1,x]
          // Add it to the potentialMatch
          potentialMatch = [firstIndex]
          // Reset the current imageObj to that of the next image.
          currentImageObj = (y+1) < this.props.rows ? tileData[y+1][x].data: null
        }
      }
    }
    return matches
  }

  getAllMatches(tileData) {
    let rowMatches = this.checkRowsForMatch(tileData);
    let colMatches = this.checkColsForMatch(tileData);
    return [...rowMatches, ...colMatches];
  }

  markAsMatch(matches, tileData, counter) {
    let value = 0;
    matches.forEach(match => {
      match.forEach(e => {
        let y = e[0];
        let x = e[1];
        tileData[y][x].markedAsMatch = true;
        value += (tileData[y][x].data.value1 * counter);
      });
    });
    return value;
  }

  condenseColumns(tileData) {
    // Get number of rows and number of columns.
    let spotsToFill = 0;
    for (let x = 0; x < this.props.columns; x++) {
      spotsToFill = 0;
// Iterate through each column
      for (let y = this.props.rows - 1; y >= 0; y--) {
// Check to see if the element is a spot that needs filling.
        if (tileData[y][x].markedAsMatch == true) {
          // Increment the spots to fill since we found a spot to fill.
          spotsToFill++;
          // Place the location above the top of the screen for when it "falls"
          // tileData[y][x].location.set({
          //   x: this.props.size * x,
          //   y: -4 * this.props.size
          // });
          tileData[y][x].locationX.set(
            this.props.size * x
          );
          tileData[y][x].locationY.set(
            -this.props.size
          );
        } else if (spotsToFill > 0) {
          // Move bean downward
          const currentSpot = tileData[y][x];
          tileData[y][x] = tileData[y + spotsToFill][x];
          tileData[y + spotsToFill][x] = currentSpot;
        }
      }
    }
  }
}

class TileData {

  constructor(data, key, i) {
    this.key = key;
    this.markedAsMatch = false;
    this.location = new SpringValue({x: 0, y: 0});
    this.locationX = new SpringValue(0);
    this.locationY = new SpringValue(0);
    this.data = data;
    this.scale = new SpringValue(1);
  }
}

class Tile extends React.PureComponent {

  render() {
    const size = this.props.size;
    return (
      <animated.div
        style={{
          width: size,
          height: size,
          display: 'flex',
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
          // transform: [{translateX: this.props.location.x}, {translateY: this.props.location.y}]
          // transform: `translate(${this.props.locationX}px, ${this.props.locationY}px)`,
          left: this.props.locationX,
          top: this.props.locationY,
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          MsUserSelect: "none",
          UserSelect: "none",
        }}>
        <AppImage
          style={{pointerEvents: 'none', width: size - 8, height: size - 8, borderRadius: RadiusView}}
          imageUrl={this.props.img}
        />
      </animated.div>
    );
  }
}

const SwipeWrapperView = (props) => {

  const {size, onSwipeLeft, onSwipeRight, onSwipeUp, onSwipeDown} = props;

  const config = {
    delta: size,
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: true,
    rotationAngle: 0,
    swipeDuration: Infinity,
    // touchEventOptions: { passive: false },
  }

  const handlers = useSwipeable({
    onSwipedLeft: onSwipeLeft,
    onSwipedRight: onSwipeRight,
    onSwipedUp: onSwipeUp,
    onSwipedDown: onSwipeDown,
    // onSwiped: (eventData) => console.log("User Swiped!", eventData),
    ...config,
  });

  return <div {...handlers}>
    {props.children}
  </div>
};
